import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/system'
import { useIntl } from 'react-intl'

import messages from './messages'

const footerSx: SxProps<Theme> = (theme) => ({
  padding: theme.spacing(0.5, 1.5),
  color: theme.palette.customGrey.dark,
  background: theme.palette.common.white,
})

const containerSx: SxProps<Theme> = (theme) => ({
  [theme.breakpoints.up('sm')]: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})

export const Footer = () => {
  const { formatMessage } = useIntl()
  return (
    <Box sx={footerSx} component="footer">
      <Container maxWidth="xl" sx={containerSx}>
        <Stack direction="row" gap={2}>
          <Typography variant="overline">
            {formatMessage(messages.copyright, { now: new Date() })}
          </Typography>
          <Typography variant="overline">
            {formatMessage(messages.copyrightReserved)}
          </Typography>
        </Stack>
      </Container>
    </Box>
  )
}
